'use client';

import PoliceLineDivider from '@/components/police-line-divider';
import { EXAM_PROCESSES } from '@/data/exam/exam.data';
import { useEffect, useRef, useState } from 'react';

export default function Client() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (sectionRef.current) {
      const observer = new ResizeObserver(([entry]) => {
        setHeight(entry.contentRect.height);
      });

      observer.observe(sectionRef.current);
      return () => observer.disconnect();
    }
  }, []);

  return (
    <div ref={sectionRef} className="desktop:pt-10 relative">
      {/**모바일 폴리스라인 */}
      <div className="desktop:hidden absolute top-5 left-6 z-0 w-full origin-top-left rotate-90">
        <PoliceLineDivider width={height - 20} height={7} />
      </div>
      {/**웹 폴리스라인*/}
      <div className="desktop:block absolute top-26 left-9.5 z-0 hidden h-2.5 w-full origin-top-left rotate-90">
        <PoliceLineDivider width={height - 110} />
      </div>
      <div className="desktop:gap-15 relative z-1 flex flex-col justify-center gap-7">
        {EXAM_PROCESSES.map((process, idx) => (
          <div
            className="desktop:items-center desktop:gap-[51px] flex gap-2"
            key={'process' + idx}
          >
            <span className="desktop:w-[66px] desktop:h-[66px] flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white shadow-[0_4px_10px_rgba(0,0,0,0.1)]">
              <span className="desktop:pt-0 typo-16 bg-main-darkgray desktop:typo-24 desktop:w-[46px] desktop:h-[46px] flex h-[27px] w-[27px] shrink-0 items-center justify-center rounded-full pt-0.5 font-bold text-white">
                {String(idx + 1).padStart(2, '0')}
              </span>
            </span>
            <div className="bg-bg-graylight desktop:pl-15 desktop:flex-row desktop:rounded-2xl desktop:w-[953px] desktop:py-[42px] desktop:items-center flex grow flex-col gap-4 rounded-xl p-5">
              <div className="desktop:text-level-3 desktop:typo-28 desktop:font-extrabold text-level-1 typo-18 desktop:w-[278px] shrink-0 font-bold">
                {process.title}
              </div>
              <div className="desktop:gap-3 flex flex-col gap-2.5">
                {process.content.map((content, idx) => (
                  <span
                    key={'content' + idx}
                    className="text-level-4 desktop:typo-22 desktop:gap-3 typo-16 desktop:leading-snug flex gap-2 leading-snug font-semibold"
                  >
                    <span className="bg-level-4 desktop:h-1.5 desktop:w-1.5 desktop:mt-3 mt-[7px] inline-block h-1 w-1 shrink-0 rounded-full"></span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: content.replace(/\n/g, '<br/>'),
                      }}
                    ></span>
                  </span>
                ))}
                {process.subContent &&
                  process.subContent.map((subContent, idx) => (
                    <span
                      className="typo-16 text-level-6 desktop:typo-22 desktop:pl-0 desktop:gap-2 flex gap-1 pl-3 leading-snug font-medium"
                      key={'subContent' + idx}
                    >
                      {subContent}
                    </span>
                  ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
